import React from "react";
import { Navigate } from "react-router-dom";
import useAuthContext from "../../hooks/useAuthContext";
import { storedIsInternal } from "../Admin/helpers";
import TimeBoundDeliveryStats from "./TimeBoundDeliveryStats";
import "./style.scss";

const BST2Dashboard = () => {
  const {
    user: { isInternal },
  } = useAuthContext();
  const isInternalUser = Boolean(isInternal || storedIsInternal());

  if (!isInternalUser) return <Navigate to="/order-list" replace />;

  return (
    <div className="bst2_dashboard">
      <h1>BST2 Dashboard</h1>
      <TimeBoundDeliveryStats />
    </div>
  );
};

export default BST2Dashboard;
